import { inject, Injectable } from '@angular/core';
import { DocConverterHtml2PdfDto } from '@core/data-access';
import { encodeHtml } from '@core/util';
import { GenericApiService } from './generic-api.service';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocConverterApiService {
  private readonly endpoint = 'doc-converter/html2pdf';
  private readonly api = inject(GenericApiService);

  html2pdf(dto: DocConverterHtml2PdfDto): Observable<Blob> {
    const normalized = DocConverterHtml2PdfDto.fromJson(dto) as DocConverterHtml2PdfDto;
    const payload = {
      ...normalized,
      html: encodeHtml(normalized.html),
      printOptions: normalized.printOptions && {
        ...normalized.printOptions,
        headerTemplate: encodeHtml(normalized.printOptions.headerTemplate),
        footerTemplate: encodeHtml(normalized.printOptions.footerTemplate),
      },
    };
    return this.api
      .post(this.endpoint, payload, {
        requestOptions: { responseType: 'arraybuffer' },
        pretreatmentResponse: false,
      })
      .pipe(map(buffer => new Blob([buffer], { type: 'application/pdf' })));
  }
}
